const adStates = {
    ready: 'ready',
    filled: 'filled',
    empty: 'empty'
};

export default adStates;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/Areas/MyTradera/static/script/app/components/ads/ad-states.js